import { ApplyLandingPage } from '@components/Landing/ApplyLandingPage';
import AmountContainer from '@components/Apply/Amount';
import Auth0CallbackContainer from '@components/Apply/Auth0';
import { MoreDetailsOnYourBusiness } from '@components/Apply/MoreDetailsOnYourBusiness/MoreDetailsOnYourBusiness';
import { FurtherBusinessDetails } from '@components/Apply/FurtherBusinessDetails/FurtherBusinessDetails';
import { OwnersMoreDetailsAboutYou } from '@components/Apply/OwnersMoreDetailsAboutYou/OwnersMoreDetailsAboutYou';
import { FundingIsAlmostHere } from '@components/Apply/FundingIsAlmostHere/FundingIsAlmostHere';
import { TypeOfFunding } from '@components/Apply/TypeOfFunding/TypeOfFunding';
import { WhenFundingNeeded } from '@components/Apply/WhenFundingNeeded/WhenFundingNeeded';
import { BCMMoreDetailsOnYourBusiness } from '@components/Apply/MoreDetailsOnYourBusiness/BCMMoreDetailsOnYourBusiness';
import { BCMSummary } from '@components/Apply/BCMSummary/BCMSummary';
import InfoContainer from '@components/Apply/Info';
import { BCMShortInfoContainer } from '@components/Apply/InfoBcm2';
import BCMHome from '@components/BCM/BCMHome';
import { BankConnectContainer } from '@components/Apply/BankConnect/BankConnect';
import {
  ApplyWizardStep,
  ApplyWizardStepObject,
  STEP_AMOUNT,
  STEP_BUSINESS_FURTHER_DETAILS,
  STEP_BUSINESS_MORE_DETAILS,
  STEP_BUSINESS_OWNERS,
  STEP_HOMEPAGE,
  STEP_BCM_HOMEPAGE,
  STEP_INFO,
  STEP_SUMMARY,
  STEP_TYPE_OF_FUNDING,
  STEP_VERIFY_LOGIN,
  STEP_WHEN_FUNDING_NEEDED,
  STEP_BCM_INFO,
  STEP_BCM_BUSINESS_MORE_DETAILS,
  STEP_BCM_SUMMARY,
  ApplyWizardSteps,
  STEP_BANK_CONNECT,
  STEP_INTEGRATED_LOGIN,
  STEP_BCM_2_HOMEPAGE,
  STEP_BCM_2_END_AS_WILL_CONTACT,
  STEP_BCM_2_INFO,
  STEP_BCM_2_BUSINESS_MORE_DETAILS,
  STEP_BCM_2_ADD_CARD,
  STEP_EQ_LEAD_HOMEPAGE,
  STEP_EQ_LEAD_YOUR_INFORMATION,
  STEP_EQ_LEAD_YOUR_BUSINESS,
  STEP_EQ_LEAD_OWNERS_INFORMATION,
  STEP_EQ_LEAD_SUMMARY,
  STEP_EQ_LEAD_PRODUCT_DETAILS,
  STEP_EQ_LEAD_NOT_READY,
} from '@components/ApplyWizard/ApplyWizardSteps';
import { CustomLogin } from '@components/Apply/Auth/CustomLogin';
import { BCMLandingPage } from '@components/BCMShort/Landing/BCMLandingPage';
import { BCMShortMoreDetailsOnYourBusiness } from '@components/Apply/MoreDetailsOnYourBusiness/BCMShortMoreDetailsOnYourBusiness';
import { BCMShortAddCard } from '@components/BCMShort/BCMShortAddCard';
import { BCMShortEndAsWillContact } from '@components/BCMShort/BCMShortEndAsWillContact';
import { EQLandingPage } from '@components/Landing/EQLandingPage';
import { EQLeadFlowYourInformationStep } from '@components/EQLeadFlow/Step1/EQLeadFlowYourInformationStep';
import { EQLeadEquipmentInfoStep } from '@components/EQLeadFlow/Step1.5EQ/EQLeadEquipmentInfo';
import { EQLeadOwnersStep } from '@components/EQLeadFlow/Step3/EQLeadOwnersStep';
import { EQLeadSummary } from '@components/EQLeadFlow/Step4/EQLeadSummary';
import { EQLeadYourBusinessStep } from '@components/EQLeadFlow/Step2/EQLeadYourBusinessStep';
import { EmbedLearnMore } from '@components/EmbedLearnMore/EmbedLearnMore';

export const ApplyWizardStepsWithComponents: Record<ApplyWizardStep, ApplyWizardStepObject> = {
  // General
  [STEP_INTEGRATED_LOGIN]: {
    Component: CustomLogin,
    ...ApplyWizardSteps[STEP_INTEGRATED_LOGIN],
  },
  // Lead EQ Flow
  [STEP_EQ_LEAD_NOT_READY]: {
    Component: EmbedLearnMore,
    ...ApplyWizardSteps[STEP_EQ_LEAD_NOT_READY],
  },
  [STEP_EQ_LEAD_HOMEPAGE]: {
    Component: EQLandingPage,
    ...ApplyWizardSteps[STEP_EQ_LEAD_HOMEPAGE],
  },
  [STEP_EQ_LEAD_YOUR_INFORMATION]: {
    Component: EQLeadFlowYourInformationStep,
    ...ApplyWizardSteps[STEP_EQ_LEAD_YOUR_INFORMATION],
  },
  [STEP_EQ_LEAD_PRODUCT_DETAILS]: {
    Component: EQLeadEquipmentInfoStep,
    ...ApplyWizardSteps[STEP_EQ_LEAD_PRODUCT_DETAILS],
  },
  [STEP_EQ_LEAD_YOUR_BUSINESS]: {
    Component: EQLeadYourBusinessStep,
    ...ApplyWizardSteps[STEP_EQ_LEAD_YOUR_BUSINESS],
  },
  [STEP_EQ_LEAD_OWNERS_INFORMATION]: {
    Component: EQLeadOwnersStep,
    ...ApplyWizardSteps[STEP_EQ_LEAD_OWNERS_INFORMATION],
  },
  [STEP_EQ_LEAD_SUMMARY]: {
    Component: EQLeadSummary,
    ...ApplyWizardSteps[STEP_EQ_LEAD_SUMMARY],
  },
  // BCM Short
  [STEP_BCM_2_HOMEPAGE]: {
    Component: BCMLandingPage,
    ...ApplyWizardSteps[STEP_BCM_2_HOMEPAGE],
  },
  [STEP_BCM_2_INFO]: {
    Component: BCMShortInfoContainer,
    ...ApplyWizardSteps[STEP_BCM_2_INFO],
  },
  [STEP_BCM_2_BUSINESS_MORE_DETAILS]: {
    Component: BCMShortMoreDetailsOnYourBusiness,
    ...ApplyWizardSteps[STEP_BCM_2_BUSINESS_MORE_DETAILS],
  },
  [STEP_BCM_2_ADD_CARD]: {
    Component: BCMShortAddCard,
    ...ApplyWizardSteps[STEP_BCM_2_ADD_CARD],
  },
  [STEP_BCM_2_END_AS_WILL_CONTACT]: {
    Component: BCMShortEndAsWillContact,
    ...ApplyWizardSteps[STEP_BCM_2_END_AS_WILL_CONTACT],
  },
  // BCM
  [STEP_BCM_HOMEPAGE]: {
    Component: BCMHome,
    ...ApplyWizardSteps[STEP_BCM_HOMEPAGE],
  },
  [STEP_BCM_SUMMARY]: {
    Component: BCMSummary,
    ...ApplyWizardSteps[STEP_BCM_SUMMARY],
  },
  [STEP_BCM_INFO]: {
    Component: InfoContainer,
    ...ApplyWizardSteps[STEP_BCM_INFO],
  },
  [STEP_BCM_BUSINESS_MORE_DETAILS]: {
    Component: BCMMoreDetailsOnYourBusiness,
    ...ApplyWizardSteps[STEP_BCM_BUSINESS_MORE_DETAILS],
  },
  // Apply
  [STEP_HOMEPAGE]: {
    ...ApplyWizardSteps[STEP_HOMEPAGE],
    Component: ApplyLandingPage,
  },
  [STEP_AMOUNT]: {
    Component: AmountContainer,
    ...ApplyWizardSteps[STEP_AMOUNT],
  },
  [STEP_INFO]: {
    Component: InfoContainer,
    ...ApplyWizardSteps[STEP_INFO],
  },
  [STEP_VERIFY_LOGIN]: {
    Component: Auth0CallbackContainer,
    ...ApplyWizardSteps[STEP_VERIFY_LOGIN],
  },
  [STEP_BUSINESS_MORE_DETAILS]: {
    Component: MoreDetailsOnYourBusiness,
    ...ApplyWizardSteps[STEP_BUSINESS_MORE_DETAILS],
  },
  [STEP_BANK_CONNECT]: {
    Component: BankConnectContainer,
    ...ApplyWizardSteps[STEP_BANK_CONNECT],
  },
  [STEP_BUSINESS_FURTHER_DETAILS]: {
    Component: FurtherBusinessDetails,
    ...ApplyWizardSteps[STEP_BUSINESS_FURTHER_DETAILS],
  },
  [STEP_BUSINESS_OWNERS]: {
    Component: OwnersMoreDetailsAboutYou,
    ...ApplyWizardSteps[STEP_BUSINESS_OWNERS],
  },
  [STEP_TYPE_OF_FUNDING]: {
    Component: TypeOfFunding,
    ...ApplyWizardSteps[STEP_TYPE_OF_FUNDING],
  },
  [STEP_WHEN_FUNDING_NEEDED]: {
    Component: WhenFundingNeeded,
    ...ApplyWizardSteps[STEP_WHEN_FUNDING_NEEDED],
  },
  [STEP_SUMMARY]: {
    Component: FundingIsAlmostHere,
    ...ApplyWizardSteps[STEP_SUMMARY],
  },
};
